import React from 'react'
import {connect} from 'react-redux'
import {
    fileAdd,
    fileError,
    fileProgress,
    fileSuccess,
    fileUpdate,
} from "../../actions/FileActions";
import axios from 'axios';
import FileEntity, {createUid} from '../../helpers/FileEntity';
import Uploader from "./Uploader";
import {extensionByName} from "../../../../../common/helpers/FileExtention";
import PropTypes from "prop-types";
import {FILE_TYPE_FILE, FILE_TYPE_LINK, FILE_TYPE_TO_CONVERT} from "../../constants/FileTypeConstant";
import SlackService from "../../../../../common/services/SlackService";

class FileUploader extends Uploader {

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {formFiles} = this.props;

        if (prevProps.formFiles !== formFiles && formFiles.length) {
            this.handleFiles(formFiles);
        }
    }

    prepareConvert = (fileEntity, file) => {
        const {dependencies} = this.props;

        if(!dependencies.needConvertFormats.includes(fileEntity.extension)) {
            return true;
        }
        const formData = new FormData();
        formData.append('originalName', fileEntity.originalName);
        formData.append('file', file);

        return axios.post('/api/file/prepare-convert', formData).then(res => {return res.data;});
    };

    fetchDuration = (file) => {
        var objectUrl = URL.createObjectURL(file);

        return new Promise((resolve) => {
            const audio = new Audio();
            audio.src = objectUrl;
            audio.addEventListener(
                'loadedmetadata',
                () => {
                    resolve(audio.duration)
                },
            );
        })
    }

    getSignedUrl = (fileEntity) => {
        const formData = new FormData();
        formData.append('originalName', fileEntity.originalName);

        return axios.post('/api/file/presigned-url', formData).then(res => {
            return res.data;
        })
    };

    uploadToS3 = (fileEntity, url, file) => {
        return axios.put(url, file, {
            onUploadProgress: progressEvent => this.onProgress(fileEntity, progressEvent),
        }).then(res => {
            return res.data;
        });
    };

    onProgress = (fileEntity, progressEvent) => {
        const progress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        this.props.fileProgress(fileEntity, progress);
    };

    finishCallback = (files, file) => {
        if (files[files.length - 1] === file) {
            setTimeout(() => {
                this.props.finishCallback()
            }, 200)
        }
    }

    replaceExtension = (file) => {
        return file.replace(/\.[^.]+$/, '.mp3');
    }

    handleFiles = (files) => {
        const {fileItems, dependencies} = this.props;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            const fileEntity = new FileEntity({
                uid: createUid(),
                originalName: file.name,
                size: file.size,
                extension: extensionByName(file.name),
            });

            this.props.fileAdd(fileEntity);

            if(dependencies.needConvertFormats.includes(fileEntity.extension)) {
                this.validate(fileItems, fileEntity, dependencies).then(() => {
                    return this.prepareConvert(fileEntity, file);
                }).then(data => {
                    fileEntity.path = data.path;
                    return this.fetchDuration(file);
                }).then(data => {
                    fileEntity.mime = file.type;
                    fileEntity.duration = parseInt(data);
                    return this.save(fileEntity, FILE_TYPE_TO_CONVERT);
                }).then(data => {
                    //fileEntity.originalName = this.replaceExtension(fileEntity.originalName);
                    //fileEntity.name = this.replaceExtension(fileEntity.name);
                    //fileEntity.mime = 'audio/mpeg';

                    fileEntity.name = data.path;
                    this.props.fileSuccess(fileEntity);
                    this.props.fileUploadedCallback(fileEntity);
                    this.finishCallback(files, file);
                }).catch(error => {
                    this.props.fileError(fileEntity, error);
                    this.finishCallback(files, file);
                    let fileData = SlackService.prepareTranscriptionData(fileEntity, null);
                    SlackService.send(` - *guest can't upload file* :musical_note: ${fileData}`);
                });
            } else {
                this.validate(fileItems, fileEntity, dependencies).then(() => {
                    return this.getSignedUrl(fileEntity);
                }).then(data => {
                    fileEntity.source = data.url;
                    return this.uploadToS3(fileEntity, data.url, file)
                }).then(() => {
                    return this.getMediaInfo(fileEntity);
                }).then(data => {
                    fileEntity.duration = data.duration;
                    fileEntity.size = data.size;
                    fileEntity.mime = data.mime;
                    fileEntity.extension = data.extension;
                    return this.save(fileEntity, FILE_TYPE_FILE);
                }).then(data => {
                    fileEntity.name = data.path;
                    this.props.fileSuccess(fileEntity);
                    this.props.fileUploadedCallback(fileEntity);
                    this.finishCallback(files, file);
                }).catch(error => {
                    this.props.fileError(fileEntity, error);
                    this.finishCallback(files, file);
                    let fileData = SlackService.prepareTranscriptionData(fileEntity, null);
                    SlackService.send(` - *guest can't upload file* :musical_note: ${fileData}`);
                });
            }
        }
    };

    render() {
        return null;
    }
}

FileUploader.propTypes = {
    fileUploadedCallback: PropTypes.func,
    finishCallback: PropTypes.func,
    dependencies: PropTypes.any,
    formFiles: PropTypes.any,
    fileItems: PropTypes.any,
};

FileUploader.defaultProps = {
    fileUploadedCallback: () => {},
    finishCallback: () => {},
};

export default connect(
    state => ({
        dependencies: state.dictionary.dependencies,
        formFiles: state.fileForm.files,
        fileItems: state.file.files,
    }),
    dispatch => ({
        fileAdd: (fileEntity) => dispatch(fileAdd(fileEntity)),
        fileUpdate: (fileEntity) => dispatch(fileUpdate(fileEntity)),
        fileProgress: (fileEntity, progress) => dispatch(fileProgress(fileEntity, progress)),
        fileSuccess: (fileEntity) => dispatch(fileSuccess(fileEntity)),
        fileError: (fileEntity, message) => dispatch(fileError(fileEntity, message)),
    })
)(FileUploader);
